import { RequestConfig } from '~/common/services/requests';
import { ModelOption } from '../../../../types';
import { ConstructGet } from '../../../types/ConstructGet';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { USER_BASE_PATH } from '../constants/userBasePath';

export const getUserOptions = (
  constructGet: ConstructGet,
  params?: RequestConfig['params'],
): Promise<NonPaginatedResponse<ModelOption[]> | undefined> =>
  constructGet<NonPaginatedResponse<ModelOption[]>>(
    `${USER_BASE_PATH}/options`,
    {
      params,
    },
  );
